export function RadioInputIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x='4.5' y='4.5' width='15' height='15' rx='7.5' fill='transparent' />
      <rect x='4.5' y='4.5' width='15' height='15' rx='7.5' stroke='currentColor' />
    </svg>
  )
}
